import template from './branch_funding_source_holiday.edit.html';
import controller from './branch_funding_source_holiday.edit.controller';
import './branch_funding_source_holiday.edit.html';

let BranchFundingSourceHolidayEditComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template,
    controller
};

export default BranchFundingSourceHolidayEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source_holiday/edit/branch_funding_source_holiday.edit.component.js